// @flow

import buildFeedbackHelpers from 'app/packages/pin-utils/feedbackHelpers';
import i18n from 'app/common/lib/i18n';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { type Pin } from 'app/common/react/components/PinRep/types';
import {
  type FeedbackOptions,
  type FeedbackType,
} from 'app/common/react/components/PinRep/feedback-types';

type GetFeedbackTypeArgs = {|
  pin: Pin,
  feedbackOptions?: FeedbackOptions,
  viewParameter?: $Values<PCONST.thrift.ViewParameterType>,
|};

// This is a convenience wrapper around the functions provided by `feedbackHelpers`,
// which have their own unit tests. No tests needed for this wrapper.
export default function getFeedbackType({
  feedbackOptions,
  pin,
  viewParameter,
}: GetFeedbackTypeArgs): FeedbackType {
  const { board, pinner } = pin;

  const { getFeedbackType: getFeedbackTypeHelper } = buildFeedbackHelpers({
    i18n,
    interpolateNamedTemplate,
  });

  return getFeedbackTypeHelper({
    board,
    feedback: feedbackOptions,
    pin,
    pinner,
    viewParameter,
  });
}
